import _ from "lodash";
import { DatesGenerator } from "../../../utils/dates-generator/dates-generator";
import { PointsAccountingAnalytics } from "../../services/PointsAccountingAnalytics/PointsAccountingAnalytics";
import { SeriesAccountingAnalytics } from "../../services/SeriesAccountingAnalytics/SeriesAccountingAnalytics";

import { AccountingAnalyticsCalculate } from "./AccountingAnalyticsCalculate";
export class AccountingAnalytics {
    constructor({ Company, SocialUser } = {}) {
        this.Company = Company;

        this.SocialUser = SocialUser;

        this.Points = new PointsAccountingAnalytics();
        this.Series = new SeriesAccountingAnalytics({});

        this.Calculate = new AccountingAnalyticsCalculate({
            Series: this.Series,
            Points: this.Points
        });
    }

    setAccountingId(accountingId) {
        this.accountingId = accountingId;
    }

    getGroupByField(field) {
        const fields = {
            taxation: [
                "Lucro Presumido",
                "Lucro Real",
                "Simples Nacional",
                "MEI",
                "Pessoa Física",
                "Outros"
            ],
            segmentGroup: ["Comércio", "Indústria", "Serviço", "Outros"],
            category: ["A", "B", "C", "D"],
            owner: this.SocialUser.getSimplfyUser(this.accountingId),
            source: [
                {
                    value: "Contábil",
                    model: "accounting"
                },
                {
                    value: "Financeiro",
                    model: "fin"
                },
                {
                    value: "Pessoal",
                    model: "personnel"
                },
                {
                    value: "Fiscal",
                    model: "tax"
                }
            ],
            score: ["ALTO", "MEDIO", "BAIXO"]
        };

        const listFields = fields[field];

        return listFields;
    }

    distinct(field) {
        if (!field) return [];

        return [...new Set(this.companies.map((c) => _.get(c, `${field}`)))];
    }

    result({ serieIds = [], timesBetween, filterQuery = {} }) {
        serieIds = [].concat(serieIds);

        return this.Calculate.result({
            serieIds,
            timesBetween,
            filterQuery,
            dates: DatesGenerator.getDates()
        });
    }

    generateSeriesByField(
        { field, baseId, unit, func, refereceId },
        typeReturn = false
    ) {
        const listFields = this.getGroupByField(field);

        const _ids = this.Series.generateTypeGrouped(
            {
                listFields,
                field,
                baseId,
                unit,
                func,
                refereceId
            },
            typeReturn
        );

        return _ids;
    }

    getSeries({ selector, options }) {
        return this.Series.findCollection(selector, options, "array");
    }

    getPoints({ selector, options }) {
        return this.Points.findCollection(selector, options, "array");
    }

    getCount(selector) {
        this.Points.countCollection(selector);
    }

    populate() {
        this.Points.findCollection({}, {}, "array");

        this.Series.default();

        this.Series.findCollection({}, {}, "array");

        return [];
    }
}
